// extracted by mini-css-extract-plugin
export default {"infoPanel":"InfoPanel_infoPanel__5lyx-","default":"InfoPanel_default__keHYr","spacer":"InfoPanel_spacer__1U4Ah"};